// extracted by mini-css-extract-plugin
export var accordion = "_b3-0";
export var chevron = "_b3-3";
export var closed = "_b3-2";
export var content = "_b3-4";
export var open = "_b3-1";
export var rotate = "_b3-5";